import React from 'react'
import scrollimg from "../../../assets/images/scrooll.png"

import styled from '@emotion/styled';
import { Grid } from '@mui/material';

const Iasdmg = styled.img`  
width: 100%;
height:auto;
max-width: ${(props) => (props.maxWidth ? props.maxWidth : "300px")};
`
const Div = styled.div`
 /* background: ${(props) => (props.bgcolor ? props.bgcolor : "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)")}; */
  border-top: 1px solid #F8BA3F;
  border-bottom: 1px solid #F8BA3F;
  padding: ${(props) => (props.padding ? props.padding : "8px 0")};
`
const GridInside = styled(Grid)`
display: flex;
    place-content: center;
`

const Swipe = (props) => {
    return (
        // "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)"
        <Div bgcolor={props.bgcolor}>
            <marquee scrollamount={props.scrollamount} behavior="scroll" direction="left" loop="infinite">
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
            </marquee>
        </Div>
    )
}

export default Swipe